import { useState } from 'react';
import { userReviews } from '@/mocks/homeData';

export default function UserReviews() {
  const [current, setCurrent] = useState(0);

  const review = userReviews[current];

  const handlePrev = () => {
    setCurrent((prev) => (prev === 0 ? userReviews.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrent((prev) => (prev === userReviews.length - 1 ? 0 : prev + 1));
  };

  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="w-full lg:w-[60%] flex flex-col">
            <div className="flex items-center gap-2 mb-6">
              <span className="w-2 h-2 rounded-full bg-primary-500"></span>
              <span className="text-sm font-semibold text-foreground-700">
                网友热评
              </span>
            </div>
            <blockquote className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-950 leading-relaxed mb-6">
              <span className="text-primary-400 text-5xl md:text-6xl leading-none">&ldquo;</span>
              {review.quote}
            </blockquote>
            <div className="flex items-center gap-3">
              <span className="text-sm font-bold text-foreground-950">
                {review.author}
              </span>
              <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                <i className="ri-verified-badge-line text-sm"></i>
                {review.badge}
              </span>
            </div>
            <div className="flex items-center gap-2 mt-6">
              <button
                onClick={handlePrev}
                className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-300 text-foreground-600 hover:bg-foreground-100 hover:text-foreground-950 cursor-pointer transition-all duration-200"
                aria-label="上一条评价"
              >
                <i className="ri-arrow-left-line"></i>
              </button>
              <button
                onClick={handleNext}
                className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-300 text-foreground-600 hover:bg-foreground-100 hover:text-foreground-950 cursor-pointer transition-all duration-200"
                aria-label="下一条评价"
              >
                <i className="ri-arrow-right-line"></i>
              </button>
              <div className="flex items-center gap-1.5 ml-3">
                {userReviews.map((_, idx) => (
                  <button
                    key={idx}
                    onClick={() => setCurrent(idx)}
                    className={`w-2 h-2 rounded-full cursor-pointer transition-all duration-300 ${
                      idx === current ? 'bg-primary-500 w-4' : 'bg-foreground-300'
                    }`}
                    aria-label={`第 ${idx + 1} 条评价`}
                  />
                ))}
              </div>
            </div>
          </div>

          <div className="w-full lg:w-[40%] flex justify-center lg:justify-end">
            <div className="relative w-56 h-72 md:w-64 md:h-80 rounded-2xl overflow-hidden">
              <img
                src={review.image}
                alt={review.author}
                title={`吃瓜网 - ${review.author}`}
                className="w-full h-full object-cover object-top grayscale"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}